import { FormControlLabel, Switch, SwitchProps, styled } from "@mui/material";
import * as React from "react";

declare const window: any;

export default function DetailSelectedContainer({
    detail,
    setMenuSelected,
    setSubMenuSelected,
    colors,
    theme,
    setIsTheme,
    setFrame
}: any) {
    const [show, setShow] = React.useState("")
    /* React.useEffect(() => {
        const setting_botton: any = document.querySelector(".setting-boton-circular");
        if (setting_botton) {
            setting_botton.style.backgroundColor = colors?.main_buttons;
        }
    }, []) */

    return (
        <div className={`title-detail-container ${theme}`}>
            {detail.replace(/\d+/g, (match: any) => ` ${match} `).split(/(?=[A-Z])/).join(" ")} | <i className="fas fa-xmark" onClick={() => {setMenuSelected(""), setSubMenuSelected(""), setFrame(1)}}></i>
        </div>
    );
}
